import CommonStyles from 'CommonStyles';
import {StyleSheet} from 'react-native';

export default StyleSheet.create({
  text: {
    fontFamily: 'Open Sans',
    fontWeight: '400',
    fontSize: 13,
    lineHeight: 20,
    fontStyle: 'normal',
    left: 3,
    color: '#000',
    flexDirection: 'row',
    alignItems: 'baseline',
    justifyContent: 'flex-start',
    marginTop: 20,
  },
  link: {
    color: '#0066CC',
    textDecorationLine: 'underline',
  },
  checkboxIcon: {
    height: 15,
    width: 15,
    alignSelf: 'center',
    backgroundColor: 'transparent',
  },
  checkboxContainer: {
    position: 'absolute',
    left: -25,
    bottom: 0,
    top: 4,
    marginTop: 20,
  },

  checkboxWrapper: {
    height: 22,
    width: 22,
    borderRadius: 4,
    borderWidth: 1,
    borderColor: 'rgba(0, 0, 0, 0.4)',
    backgroundColor: 'white',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
  },

  message: {
    flex: 1,
    ...CommonStyles.text12,
    opacity: 0.8,
  },
});
